import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from "@/shared/constants";
import { IBancoPagingRes } from "@/shared/interfaces/erp/administration/bancos.interface";
import { useQuery } from "@tanstack/react-query";


const { get} = erpApi();


export type GetBancoParams = {
  page?: number;
  page_size?: number;
  nombre?: string;
};


export const useFetchBancos = ({
  page = 1,
  page_size = 10,
  nombre = '',
}: GetBancoParams) => {
  return useQuery({
    queryKey: ['banco', page, nombre, page_size],
    queryFn: async () => {
      return getBancos({ page, nombre, page_size });
    },
  });
};

export const getBancos = async (params?: GetBancoParams) => {
  const { page = 1, page_size = 10, nombre = '' } = params || {};

  return get<IBancoPagingRes>(
    `${urlBackend}api/v1/bancos/?page=${page}&page_size=${page_size}&nombre=${nombre}`,
    true
  );
};
